/* eslint-disable */
export default {
  title: 'Historique',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
